<template>
  <div v-if="missing.length">
    <div v-if="missing[0].override_popup_title">
      <h2 class="popup-message-title">{{ missing[0].label }}</h2>
    </div>
    <div v-else>
      <h2 class="popup-message-title">{{ $t('participation.missing_custom_fields.title') }}</h2>
      <p>{{ $t('participation.missing_custom_fields.header') }}</p>
    </div>
    <form class="basicForm">
      <div v-for="customField in missing" class="form-row" :key="customField.ident">
        <div v-if="customField.options.renderer">
          <div v-if="customField.options.renderer === 'SelectWithImage'">
            <p v-if="!customField.override_popup_title">{{ customField.label }}</p>
            <div v-for="(opt, i) in customField.options.options" class="form-item form-item-100 checkbox-radiobutton checkboxtable" :key="'cfOpt'+i" >
              <input :value="opt.value" v-model="customData[customField.ident]" type="checkbox" class="form-check-input" :id="opt.value"/>
              <label :for="opt.value">
                <b v-html="opt.label"/><br/>
                <img :src="opt.image">
              </label>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-if="customField.type == 'Text'" class="form-item form-item-40">
            <label>{{ customField.label}}</label>
            <input :name="customField.ident" type="text" v-model="customData[customField.ident]"/>
          </div>
          <div v-if="customField.type == 'Select' && customField.options.render_as_select">
            TODO SELECT {{customField}}
          </div>
          <div v-if="customField.type == 'Select' && !customField.options.render_as_select && customField.options.multiple">
            <p>{{ customField.label }}</p>
            <div v-for="(opt, i) in customField.options.options" class="form-item form-item-100 checkbox-radiobutton checkboxtable" :key="'cfOpt'+i" >
              <input :value="opt.value" v-model="customData[customField.ident]" type="checkbox" class="form-check-input" :id="opt.value"/>
              <label :for="opt.value" v-html="opt.label"></label>
            </div>
          </div>
          <div v-if="customField.type == 'Select' && !customField.options.render_as_select && !customField.options.multiple">
            <p>{{ customField.label }}</p>
            <div v-for="(opt, i) in customField.options.options" class="form-item form-item-100 checkbox-radiobutton checkboxtable" :key="'cfOpt'+i" >
              <input :value="opt.value" v-model="customData[customField.ident]" type="radio" class="form-check-input" :id="opt.value"/>
              <label :for="opt.value" v-html="opt.label"></label>
            </div>
          </div>
        </div>
      </div>

      <div id="submitOrBusy" class="form-submit">
        <button class="btn-primary" v-if="axiosBusy" disabled>
          <span class="spinner-border spinner-border-sm" role="status"
            aria-hidden="true" />{{ $t('form.generic.btn_spinner') }}</button>
        <button class="btn-primary" v-else
          v-on:click.prevent="storeCustomData()" >{{ $t('form.generic.btn_save') }}</button>
      </div>
    </form>

  </div>
</template>

<script>
import { getCustomData, updateCustomData } from "@/api/custom_data.js";
import { mapGetters } from "vuex";

export default {
  name: 'CustomFields',
  props: {
    missing: Array,
    campaign: String,
  },
  data() {
    return {
      customData: {
      },
    };
  },
  computed: {
    ...mapGetters({
      axiosBusy: "axiosIsBusy",
    }),
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      let vm = this;
      this.missing.forEach( async customField => {
        const rv = await getCustomData(vm.$userClient, customField.ident);
        if (rv && rv[customField.ident].value) {
          vm.$set(vm.customData, customField.ident ,  rv[customField.ident].value);
        }
      });
    },
    async storeCustomData() {
      let vm = this;
      await updateCustomData(vm.$userClient, this.campaign, vm.customData);
      setTimeout(function() {
        vm.$emit('data-submitted');
      }, 300);
    }
  }
}
</script>
